import useGeneralSettingsStore from '../../../stores/GeneralSettings/useGeneralSettingsStore';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../../translation/TranslationContext';
import { ActionEnum } from '../actions/types/orderActions.types';
import { OrderActionProps } from '../actions/types/orderActionsContext.types';
import { useOrderContext } from '../contexts/Order.context';
import { useOrderActionsContext } from '../contexts/OrderActions.context';
import { useOrderEditSectionsContext } from '../edit/sections/OrderEditSections.context';
import { FinishButtonOverride } from './finishFlowHandler.types';
import finishFlowHandlers from './finishFlowHandlers';

const useFinishFlow = () => {
  const { translate } = useTranslation();
  const { order } = useOrderContext();
  const { isBrand } = useApplicationContext();
  const { conditionsErrors: conditionErrors } = useOrderEditSectionsContext();
  const { onClickOrderAction } = useOrderActionsContext();
  const { autoContractGeneration, orderContractSignatureRequired } = useGeneralSettingsStore(
    (s) => s.generalSettings,
  );

  const ctx = {
    order: { id: order?.id ?? '', signedContracts: order?.signedContracts ?? [] },
    settings: { autoContractGeneration, orderContractSignatureRequired },
    conditionErrors,
    isBrand,
    translate,
  };

  const getOnclick = (action: ActionEnum) => {
    if (!order) {
      return;
    }

    return () => onClickOrderAction(action, OrderActionProps.orderToProps(order));
  };

  const rawButtonOverride = finishFlowHandlers.reduce<FinishButtonOverride | null>(
    (acc, h) => acc ?? h.getButtonOverride?.(ctx) ?? null,
    null,
  );

  return {
    buttonOverride: rawButtonOverride
      ? { ...rawButtonOverride, onClick: getOnclick(rawButtonOverride.clickAction) }
      : null,
  };
};

export default useFinishFlow;
